import React, { useEffect } from 'react';

import { useAppDispatch } from 'app/config/store';
import { logout } from 'app/shared/reducers/authentication';
import { useTranslation } from 'app/shared/i18n';
import { colors } from 'app/shared/theme/colors';

export const Logout = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(logout());
    // Clear announcement login flags so they reappear on next login
    try {
      Object.keys(sessionStorage)
        .filter(k => k.startsWith('ann-login-flag-'))
        .forEach(k => sessionStorage.removeItem(k));
    } catch {
      /* ignore */
    }
    // Small delay so user sees the message before redirect
    const timer = setTimeout(() => {
      window.location.href = '/';
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <div
        className="ms-card"
        style={{
          padding: '40px 48px',
          textAlign: 'center',
          maxWidth: 400,
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            margin: '0 auto 16px',
            background: 'rgba(16, 185, 129, 0.1)',
            border: `2px solid ${colors.success}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 24,
          }}
        >
          ✓
        </div>
        <h3 style={{ fontSize: 18, fontWeight: 700, color: colors.text, marginBottom: 8 }}>{t('logout.title')}</h3>
        <p style={{ fontSize: 13, color: colors.dim, margin: 0 }}>{t('logout.redirecting')}</p>
      </div>
    </div>
  );
};

export default Logout;
